// src/components/contact/Form.tsx
import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useContactForm } from "../../hooks/useForm";
import ConfirmPopUp from "../../components/contact/ComfirmPopUp";
import Button from "../button";
import "../../scss/index.scss";
import "../../scss/contact/form.scss";

const Form: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const preFilledEmail = searchParams.get("email") || "";

  const {
    formData,
    errors,
    loading,
    feedback,
    showPopup,
    handleChange,
    handleSubmit,
    setShowPopup,
  } = useContactForm(preFilledEmail);

  const handleNavLinkClick = () => window.scrollTo(0, 0);

  return (
    <div className="col-12 col-lg-8">
      <div className="form">
        <form className="c-form__form" onSubmit={handleSubmit}>
          <input
            className="c-form__input"
            type="text"
            name="name"
            placeholder="Naam & Voornaam"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <span className="error">{errors.name}</span>}

          {preFilledEmail ? (
            <input
              className="c-form__input"
              type="email"
              name="email"
              value={preFilledEmail}
              readOnly
            />
          ) : (
            <input
              className="c-form__input"
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
            />
          )}
          {errors.email && <span className="error">{errors.email}</span>}

          <select
            className="c-form__input c-form__select"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
          >
            <option value="">Onderwerp</option>
            <option value="Vrijblijvend advies">Vrijblijvend advies</option>
            <option value="Aanvraag offerte">Offerte aanvragen</option>
          </select>
          {errors.subject && <span className="error">{errors.subject}</span>}

          <input
            className="c-form__input"
            type="tel"
            name="tel"
            placeholder="Telefoon"
            value={formData.tel}
            onChange={handleChange}
          />
          {errors.tel && <span className="error">{errors.tel}</span>}

          <textarea
            className="c-form__input"
            name="message"
            rows={3}
            placeholder="Bericht"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          {errors.message && <span className="error">{errors.message}</span>}

          <label className="c-form__policy">
            <input
              className="c-form__checkbox"
              type="checkbox"
              name="privacyAgreement"
              checked={formData.privacyAgreement}
              onChange={handleChange}
            />
            <div className="c-form__checkboxTxt">
              Ik ga akkoord met de{" "}
              <Link
                className="c-form__policyLink"
                to="/privacypolicy"
                onClick={handleNavLinkClick}
              >
                Privacy policy
              </Link>
            </div>
          </label>
          {errors.privacyAgreement && (
            <span className="error">{errors.privacyAgreement}</span>
          )}

          {loading && (
            <div className="loaderPosition">
              <div className="loaderDescription">Verzenden...</div>
              <div className="lds-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
          )}

          <Button
            color="#ffffff"
            layout="display-flex-start"
            onClick={handleSubmit}
            scrollToTop={false}
          >
            Verstuur
          </Button>

          {feedback && <p className="form-message">{feedback}</p>}
        </form>
      </div>

      {showPopup && <ConfirmPopUp onClose={() => setShowPopup(false)} />}
    </div>
  );
};

export default Form;
